import styled from "@emotion/styled";
import { Text } from "atoms";
import type { SubmissionArtistDetails } from "../types";

type SubmissionArtistNameProps = SubmissionArtistDetails & {
  showThumbnail?: boolean;
  artistName?: string;
};

function SubmissionArtistName({
  name,
  showThumbnail = false,
  artistName,
}: SubmissionArtistNameProps) {
  if (!name) {
    return null;
  }

  // TODO: add thumbnail
  if (showThumbnail) {
    return null;
  }

  return <ArtistName>{artistName ?? name}</ArtistName>;
}

// TODO: fetch data.applicationId or data.artistId for thumbnail
// separate these out and only render one, preventing useless api calls
// function SubmissionArtistProfileThumbnail() {
//   useArtist hook
// }
// function SubmissionArtistApplicationThumbnail() {
//   useApplication hook
// }

const ArtistName = styled(Text)({
  margin: 0,
  padding: "5px 0 0 0",
  opacity: 0.6,
  cursor: "not-allowed",
});
ArtistName.defaultProps = {
  font: "display",
  size: "md",
};

export { SubmissionArtistName };
